import { Row, Card, Col, CardBody, CardTitle } from "reactstrap";
import React from "react";
// import { Loader } from "../../../custom/components/Loader";

const RequestToDock = ({
  goToVesselDetails,
  selectedVessel,
  selectedZone,
  setSelectedZone,
  handleRequestToDock,
  error,
  zones,
  dockingTypes,
  selectedDockingType,
  setSelectedDockingType,
}) => {
  return (
    <React.Fragment>
      <button
        className="btn btn-primary fs-6 py-1"
        onClick={() => goToVesselDetails({ vessel: selectedVessel })}
      >
        <span className="mdi mdi-chevron-left align-middle fs-3 me-2"></span>
        <span className="">Back</span>
      </button>

      <Card className="px-3 py-1 mt-4 mb-3">
        <Col>
          <h4 className="pt-3 font-weight-semibold ">Request To Dock</h4>
        </Col>
        <Row>
          <Col className="col-12">
            <label className="col-md-2 col-form-label">Request Type</label>
          </Col>
          <Col className="col-md-4 col-lg-4 col-xl-3">
            <select
              className="form-control"
              placeholder="Select permit duration"
              value={selectedDockingType}
              onChange={(e) => {
                setSelectedDockingType(e.target.value);
              }}
            >
              {dockingTypes.map((item, key) => (
                <option key={key} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </Col>
        </Row>
        <Row>
          <Col className="col-12">
            <label className="col-md-2 col-form-label">Zone</label>
          </Col>
          <Col className="col-md-4 col-lg-4 col-xl-3">
            <select
              className="form-control"
              placeholder="Select permit duration"
              value={selectedZone}
              onChange={(e) => {
                setSelectedZone(e.target.value);
              }}
            >
              {zones.map((item, key) => (
                <option key={key} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </Col>
        </Row>
        <Col>
          <Row>
            <Col className="col-md-4 col-lg-4 col-xl-3">
              <div className="mt-4 pt-2 mb-3">
                <button
                  className="btn btn-primary fs-6 w-100"
                  onClick={() => handleRequestToDock()}
                >
                  <span className="mdi mdi-check align-middle fs-3 me-2"></span>
                  <span className="">Submit Request</span>
                </button>
              </div>
            </Col>
          </Row>
        </Col>
        {error.Message && error.Message.length > 0 ? (
          <Col>
            <Card color="danger" className="text-white-50">
              <CardBody className="p-3">
                <CardTitle className="mb-2 text-white">
                  <i className="mdi mdi-block-helper me-3" />
                  Error
                </CardTitle>
                <span className="text-white">{error.Message}</span>
              </CardBody>
            </Card>
          </Col>
        ) : null}
      </Card>
    </React.Fragment>
  );
};
export default RequestToDock;
